export {
  AssetCatalogApiClient,
  assetCatalogApiClient,
  createAssetCatalogApiClient,
} from './asset-catalog-api';

export type {
  AssetCatalogFilterParams,
  AssetCatalogItemDto,
  CreateAssetCatalogDto,
  PaginatedAssetCatalogResponseDto,
  UpdateAssetCatalogDto,
} from '@peritasai/types';
